import styled from '@emotion/styled';
import { SkeletonBar, SkeletonRect } from 'src/components/Skeleton';
const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  padding-inline: 24px;
`;
const ProductSection = styled(Section)`
  padding-top: 16px;
`;
const AdyenSection = styled(Section)`
  flex: 1 0 0;
  padding-block: 16px;
`;
const NoticeWrapper = styled.div`
  padding: 8px 24px;
  width: 100%;
`;
const ButtonWrapper = styled.div`
  padding: 16px 24px 24px;
  width: 100%;
`;
export const CheckoutSkeletonContent = () => <>
    <ProductSection data-sentry-element="ProductSection" data-sentry-source-file="index.tsx">
      <SkeletonBar width='100px' height={24} radius={8} data-sentry-element="SkeletonBar" data-sentry-source-file="index.tsx" />
      <SkeletonRect width='100%' height='56px' radius={16} data-sentry-element="SkeletonRect" data-sentry-source-file="index.tsx" />
    </ProductSection>
    <AdyenSection data-sentry-element="AdyenSection" data-sentry-source-file="index.tsx">
      <SkeletonBar width='100px' height={24} radius={8} data-sentry-element="SkeletonBar" data-sentry-source-file="index.tsx" />
      <SkeletonRect width='100%' height='285px' radius={16} data-sentry-element="SkeletonRect" data-sentry-source-file="index.tsx" />
    </AdyenSection>
  </>;
export const CheckoutSkeletonFooter = () => <>
    <NoticeWrapper data-sentry-element="NoticeWrapper" data-sentry-source-file="index.tsx">
      <SkeletonRect width='100%' height='48px' radius={16} data-sentry-element="SkeletonRect" data-sentry-source-file="index.tsx" />
    </NoticeWrapper>
    <ButtonWrapper data-sentry-element="ButtonWrapper" data-sentry-source-file="index.tsx">
      <SkeletonRect width='100%' height='52px' radius={360} data-sentry-element="SkeletonRect" data-sentry-source-file="index.tsx" />
    </ButtonWrapper>
  </>;
export const CheckoutSkeleton = () => <>
    <CheckoutSkeletonContent data-sentry-element="CheckoutSkeletonContent" data-sentry-source-file="index.tsx" />
    <CheckoutSkeletonFooter data-sentry-element="CheckoutSkeletonFooter" data-sentry-source-file="index.tsx" />
  </>;